import { thewest } from 'component-library/__styling/themes'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import version from '../server/version'
import { determineMMOClientAccess } from './mmo-access'

import { initClient } from 'component-library/__App/client'
import { getWANDcrMeta } from 'component-library/tracking/nielsen/wan-meta'

// We need this to get the dependencies loaded in the correct order
require('../common/App')

const { render, routeCacheRef } = initClient({
    version,
    requireApplication: () => require('../common/App').App,
    theme: thewest,
    applicationInitialised: ({ store, config }) => {
        determineMMOClientAccess(
            config.contentApi,
            isFeatureEnabled(store.getState().toggles, 'mmo-bypass', false),
            store
        )
    },
    getDcrMeta: getWANDcrMeta,
})

if (module.hot) {
    module.hot.accept('../common/App', () => {
        if (routeCacheRef) {
            routeCacheRef.clear()
        }

        setTimeout(render)
    })
}
